import { useMemoizedContentGetter } from 'utils/contentful'
import Section from 'components/Section'
import { Carousel } from 'components/Carousels'
import { MediaImageStandard, Typography } from 'components/Contentful'
import { BLOCKS } from '@contentful/rich-text-types'
import { Button } from 'components/Button'

const ItemComponentCarousel = ({ item }) => {
  const config = item?.config || {}
  return (
    <div className=" text-white text-center p-1 mt-12 md:mt-16 rounded-lg">
      {item?.star && (
        <div className="flex items-center justify-center">
          <div data-testid="testimonial-slider-stars-container">
            <MediaImageStandard
              content={item?.star?.mediaContent}
              layout="fixed"
              className="h-[37px] w-[192px] "
              height={37}
              width={192}
              alt={item?.star?.mediaAltText || 'star'}
            />
          </div>
        </div>
      )}

      <div className="flex items-center justify-center">
        <div className="max-w-5xl" data-testid="testimonial-slider-title-section">
          {item?.title && (
            <Typography
              content={item?.title}
              variant="headingMd"
              fontWeight="bold"
              className="my-8 md:my-12"
              data-testid="testimonial-slider-title"
            />
          )}
          {item?.subTitle && (
            <Typography
              content={item?.subTitle}
              variant="headingMd"
              mobileVariant="labelMd"
              responsive={true}
              className="pb-2 leading-7 md:leading-10 font-normal!"
              data-testid="testimonial-slider-subtitle"
            />
          )}
        </div>
      </div>

      {config?.ctaHref && (
        <div className="flex justify-start">
          <Button
            track={{
              ...config?.ctaEvent,
            }}
            variant="contained"
            color="primary"
            className="shadow-md w-full lg:w-auto"
          >
            <a href={config?.ctaHref} target="_blank" rel="noreferrer" className="no-underline">
              <Typography
                content={config?.ctaText}
                className="text-white"
                variantOverride={{ [BLOCKS.PARAGRAPH]: 'bodyLg' }}
                fontWeight="bold"
              ></Typography>
            </a>
          </Button>
        </div>
      )}

      <div className="mt-2 flex items-center justify-center">
        <div data-testid="testimonial-slider-image-section">
          <MediaImageStandard
            content={item?.image}
            layout="fixed"
            className="h-[72px] w-[72px]"
            height={72}
            width={72}
            alt={item?.image?.title || 'icon'}
          />
        </div>
      </div>
      <div className="mb-8 md:mb-12 flex items-center justify-center">
        <div className="max-w-md">
          {item?.extraText && <Typography content={item?.extraText} variant="bodyXs" />}
        </div>
      </div>
    </div>
  )
}

function TestimonialSliderModule({ grid, star, disclaimer, button }) {
  const items = grid?.gridItemsCollection?.items?.map((obj) => ({ ...obj, star })) || []

  return (
    <Section contain={true} className={'bg-[#154199]'} data-testid="testimonial-slider-section">
      <Carousel
        autoPlay={true}
        carouselItems={items}
        itemComponent={ItemComponentCarousel}
        variant="preview-full"
        withIndicators={true}
        disableArrows={true}
        classNameIndicatorDots="flex bg-[#C0CBD8] mb-3 opacity-100 hover:cursor-pointer"
        classNameActiveDot="flex [&]:bg-[#56a8f6] mb-3"
        idPrefix="testimonial-slider"
        className="block p-0 [&>div]:items-baseline"
        interval={10000}
        navigateOnClick={true}
        scrollOnChange={false}
      />
      <div className="relative ">
        <div
          className="mt-10 flex items-center justify-center"
          data-testid="testimonial-slider-button-section"
        >
          {button && (
            <Button
              track={{
                ...button.event,
              }}
              variant="contained"
              color="secondary"
              className="shadow-md w-full lg:w-auto"
            >
              <a href={button?.linkHref} className="no-underline">
                <Typography
                  content={button?.linkText}
                  className=" text-[#3300FF]"
                  variantOverride={{ [BLOCKS.PARAGRAPH]: 'bodyLg' }}
                  fontWeight="bold"
                ></Typography>
              </a>
            </Button>
          )}
        </div>
        <div className=" flex items-center justify-center">
          <div className="max-w-2xl pb-10 pt-6">
            {disclaimer && (
              <Typography
                content={disclaimer?.textContent}
                className="text-white text-center"
                variant="bodyXs"
              />
            )}
          </div>
        </div>
      </div>
    </Section>
  )
}

function TestimonialSlider({ content }) {
  const { grid, star, disclaimer, button } = useMemoizedContentGetter(content, [
    'grid',
    'star',
    'disclaimer',
    'button',
  ])

  return <TestimonialSliderModule grid={grid} disclaimer={disclaimer} star={star} button={button} />
}

export { TestimonialSlider, TestimonialSliderModule }
export default TestimonialSlider
